{
  "organizationLabel": "Organização:",
  "profileDropdownAccountInfoItem": "Informações da conta (internas)",
  "profileDropdownAccountSettingsHeader": "Configurações da conta",
  "profileDropdownProductSettingsHeader": "Configurações do produto",
  "profileDropdownUserSettingsItem": "Preferências",
  "profileLegalNoticesMenuItem": "Avisos legais",
  "signOut": "Fazer logoff",
  "themeInfoTooltip": "Nem todos os aplicativos oferecem suporte ao tema escuro.",
  "userProfileName": "{firstName} {lastName}",
  "userThemeSwitchLabel": "Tema escuro"
}
